'use strict';

export default class AddController {

  /*@ngInject*/
  constructor($http, $state, $scope, Upload, toaster) {
    this.$http = $http;
    this.$state = $state;
    this.$scope = $scope;
    this.Upload = Upload;
    this.toaster = toaster;

    this.newFont = {};
  }

  $onInit() {
    this.getList();
  }

  upload(file) {
    this.toaster.pop({
      type: 'wait',
      title: '正在上传，请稍等...',
      body: file.name,
      timeout: 3000 * 1000
    });

    file.upload = this.Upload.upload({
      url: '/api/fonts/uploadFile',
      file: file,
      data: this.newFont,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    file.upload.progress((evt) => {
      file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
    });

    file.upload.success((data, status, headers, config) => {
      this.toaster.clear();
      this.$state.go('fonts');
      this.toaster.pop('success', '上传成功', file.name);
    });

    file.upload.error((err) => {
      this.toaster.clear();
      this.toaster.pop('error', '上传失败', JSON.stringify(err));
    });
  }

  getList() {
    this.$http.get('/api/AppConfGroups').then(res => {
      this.groups = res.data;
    });
  }

  toggleSelection(id) {
    let idx = this.newFont.modelGroups.indexOf(id);
    if (idx > -1) {
      this.newFont.modelGroups.splice(idx, 1);
    } else {
      this.newFont.modelGroups.push(id);
    }
  }

}



// WEBPACK FOOTER //
// ./client/app/fonts/add/add.controller.js